module.exports = __webpack_public_path__ + "img/shopping-mall.6675508e.jpg";